import {AdvancedMarker, InfoWindow, Map, useAdvancedMarkerRef, useMap} from '@vis.gl/react-google-maps';
import {useEffect} from "react";
import PropTypes from "prop-types";


export function StoreAddressMap({latitude = 0, longitude = 0, markerTitle = 'store address location', locationChanged = () => {}}) {

    const defaultCenter = {lat: latitude, lng: longitude}
    const markerPosition = {lat: latitude, lng: longitude}
    const defaultZoom = 17
    const [markerRef, marker] = useAdvancedMarkerRef();
    const map = useMap();

    useEffect(() => {
        if (map) {
            map.panTo({lat: latitude, lng: longitude});
        }
    }, [map, latitude, longitude]);
    return (<div id={"mapBox"} >
        <Map mapId={process.env.REACT_APP_GOOGLE_MAPS_STORE_ADDRESS_MAP_ID}
             defaultCenter={defaultCenter}
             defaultZoom={defaultZoom}
        >
            <AdvancedMarker
                ref={markerRef}
                position={markerPosition}
                title={markerTitle}
                draggable={true}
                onDragEnd={(event) => locationChanged({
                    lat: event.latLng.lat(),
                    lng: event.latLng.lng()
                })}
            />

            <InfoWindow
                anchor={marker}
                headerDisabled={true}
            >
                drag to change location
            </InfoWindow>
        </Map>
    </div>)
}

StoreAddressMap.propTypes = {
    latitude: PropTypes.number,
    longitude: PropTypes.number,
    locationChanged: PropTypes.func,
    markerTitle: PropTypes.string
};

